import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  mailSent: false,
  autogenerateStatus: true,
  emailLoading: false,

  selectedValue: 0,
  collectionDataList: [],
  valveControlList: [],
};

export default function ApartmentReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_APARTMENTDATA_INIT_ACTION:
      return {
        ...state,
        apartmentList: [],
        loading: true,
      };
    case actionTypes.FETCH_APARTMENTDATA_SUCCESS_ACTION:
      return {
        ...state,
        apartmentList: action.payload.response_data.apts,
        loading: false,
      };
    case actionTypes.FETCH_APARTMENTDATA_FAIL_ACTION:
      return {
        ...state,
        apartmentList: [],
        loading: false,
      };
    case actionTypes.FETCH_APARTMENTAPPUSERDATA_INIT_ACTION:
      return {
        ...state,
        appUserList: [],
        appuserloading: true,
      };
    case actionTypes.FETCH_APARTMENTAPPUSERDATA_SUCCESS_ACTION:
      return {
        ...state,
        appUserList: action.payload.response_data.users,
        appuserloading: false,
      };
    case actionTypes.FETCH_APARTMENTAPPUSERDATA_FAIL_ACTION:
      return {
        ...state,
        appUserList: [],
        appuserloading: false,
      };
    case actionTypes.DELETE_APARTMENTAPPUSERDATA_SUCCESS_ACTION:
      return {
        ...state,
        appUserList: state.appUserList.filter(
          (item) => item.rowId !== action.payload.rowId,
        ),
      };
    case actionTypes.GENERATE_COLLECTION_SUCCESS_ACTION:
      return {
        ...state,
        mailSent: action.payload.status === "success" ? true : false,
      };

    case actionTypes.FETCH_COLLECTIONISMAILSENT_SUCCESS_ACTION:
      let temp = action.payload.response_data.status == 1 ? true : false;
      return {
        ...state,
        isMailSentList: action.payload.response_data,
        mailSent: temp,
      };
    case actionTypes.FETCH_COLLECTIONISMAILSENT_FAIL_ACTION:
      return {
        ...state,
        mailSent: false,
        isMailSentList: {},
      };
    case actionTypes.FETCH_COLLECTION_REPORT_AUTO_GENERATE_SUCCESS_ACTION:
      return {
        ...state,
        autogenerateStatus:
          action?.payload?.response_data?.autoGenerateStatus == 1
            ? true
            : false,
        selectedValue: 0,
      };
    case actionTypes.FETCH_COLLECTION_REPORT_AUTO_GENERATE_FAIL_ACTION:
      return {
        ...state,
        autogenerateStatus: true,
        selectedValue: 0,
      };
    case actionTypes.FETCH_REGENERATE_SUCCESS_ACTION:
      return {
        ...state,
        getBillCycleDetailList: action.payload.response_data,
      };
    case actionTypes.FETCH_REGENERATE_FAIL_ACTION:
      return {
        ...state,
        getBillCycleDetailList: {},
      };
    case actionTypes.FETCH_COLLECTIONDATA_INIT_ACTION:
      return {
        ...state,
        collectionDataList: [],
      };
    case actionTypes.FETCH_COLLECTIONDATA_SUCCESS_ACTION:
      const collectionData = action.payload.response_Data.data.map(
        (item, i) => ({ ...item, id: i }),
      );
      let tempTotalCollectedAmount =
        (action?.payload?.response_Data &&
          action?.payload?.response_Data.data[0]?.amountPaid) ||
        0;
      localStorage.setItem("TotalCollectedAmount", tempTotalCollectedAmount);
      return {
        ...state,
        collectionDataList: collectionData,
      };
    case actionTypes.FETCH_COLLECTIONDATA_FAIL_ACTION:
      localStorage.setItem("TotalCollectedAmount", 0);
      return {
        ...state,
        collectionDataList: [],
      };
    case actionTypes.FETCH_COLLECTION_APARTMENTS_INIT_ACTION:
      return {
        ...state,
        collectionloading: true,
      };
    case actionTypes.FETCH_COLLECTION_APARTMENTS_SUCCESS_ACTION:
      return {
        ...state,
        collectionloading: false,
        collectionApartmentList: action.payload.response_data.bills,
      };
    case actionTypes.FETCH_COLLECTION_APARTMENTS_FAIL_ACTION:
      return {
        ...state,
        collectionloading: false,
        collectionApartmentList: [],
      };
    case actionTypes.FETCH_DOWNLOAD_WATER_CARD_SUCCESS_ACTION:
      return {
        ...state,
        downloadWaterCardList: action.payload.response_data.bills,
      };
    case actionTypes.FETCH_DOWNLOAD_WATER_CARD_FAIL_ACTION:
      return {
        ...state,
        downloadWaterCardList: [],
      };
    case actionTypes.CONSOLIDATED_BILL_VIEW_SUCCESS_ACTION:
      return {
        ...state,
        consolidatedbillviewlist: action.payload.response_data,
      };
    case actionTypes.CONSOLIDATED_BILL_VIEW_FAIL_ACTION:
      return {
        ...state,
        consolidatedbillviewlist: [],
      };
    case actionTypes.FETCH_PENDING_BILLS_SUCCESS_ACTION:
      return {
        ...state,
        pendingBillsList: action.payload.response_data.pendingbills,
      };
    case actionTypes.FETCH_PENDING_BILLS_FAIL_ACTION:
      return {
        ...state,
        pendingBillsList: [],
      };
    case actionTypes.FETCH_METER_WISE_CONSUMPTION_INIT_ACTION:
      return {
        ...state,
        consumptionloading: true,
        consumptionDataList: [],
      };
    case actionTypes.FETCH_METER_WISE_CONSUMPTION_SUCCESS_ACTION:
      return {
        ...state,
        consumptionDataList: action.payload.response_data,
        consumptionCount: action.payload.length,
        consumptionloading: false,
      };
    case actionTypes.FETCH_METER_WISE_CONSUMPTION_FAIL_ACTION:
      return {
        ...state,
        consumptionloading: false,
        consumptionDataList: [],
      };

    case actionTypes.SEND_APARTMENT_EMAIL_INIT_ACTION:
      return {
        ...state,
        emailLoading: true,
      };
    case actionTypes.SEND_APARTMENT_EMAIL_SUCCESS_ACTION:
      return {
        ...state,
        emailLoading: false,
      };
    case actionTypes.SEND_APARTMENT_EMAIL_FAIL_ACTION:
      return {
        ...state,
        emailLoading: false,
      };

    // ***************************valve Control************************

    case actionTypes.FETCH_VALVE_CONTROL_DATA_INIT_ACTION:
      return {
        ...state,
      };
    case actionTypes.FETCH_VALVE_CONTROL_DATA_SUCCESS_ACTION:
      return {
        ...state,
        valveControlList: action.payload.response_data.rows,
      };
    case actionTypes.FETCH_VALVE_CONTROL_DATA_FAIL_ACTION:
      return {
        ...state,
        valveControlList: [],
      };
    case actionTypes.FETCH_VIEW_BILL_COMPACT_INIT_ACTION:
      return {
        ...state,
        GetAptBillCompact: {},
      };
    case actionTypes.FETCH_VIEW_BILL_COMPACT_SUCCESS_ACTION:
      return {
        ...state,
        GetAptBillCompact: action.payload.response_data,
      };
    case actionTypes.FETCH_TEMPLATE_SUCCESS_ACTION:
      return {
        ...state,
        TemplateId: action.payload.response_data.templateid,
      };
    case actionTypes.FETCH_TEMPLATE_FAIL_ACTION:
      return {
        ...state,
        TemplateId: "",
      };
    case actionTypes.FETCH_VALVE_HISTORY_INIT_ACTION:
      return {
        ...state,
        valvehistoryList: [],
        loadinghistory: true,
      };
    case actionTypes.FETCH_VALVE_HISTORY_SUCCESS_ACTION:
      return {
        ...state,
        valvehistoryList: action.payload.response_data.valvehistory,
        loadinghistory: false,
      };
    case actionTypes.FETCH_VALVE_HISTORY_FAIL_ACTION:
      return {
        ...state,
        valvehistoryList: [],
        loadinghistory: false,
      };
    case actionTypes.FETCH_INTERIM_BILLS_SUCCESS_ACTION:
      return {
        ...state,
        interimBillDetails: action.payload.response_data,
        loadingBill: false,
      };
    case actionTypes.FETCH_INTERIM_BILLS_INIT_ACTION:
      return {
        ...state,
        interimBillDetails: {},
        loadingBill: true,
      };
    case actionTypes.FETCH_INTERIM_BILLS_FAIL_ACTION:
      return {
        ...state,
        interimBillDetails: {},
        loadingBill: false,
      };
    case actionTypes.ADD_GENERATE_WATERCARD_INIT_ACTION:
      return {
        ...state,
        loadingGeneration: true,
      };
    case actionTypes.ADD_GENERATE_WATERCARD_SUCCESS_ACTION:
      return {
        ...state,
        loadingGeneration: false,
      };
    case actionTypes.ADD_GENERATE_WATERCARD_FAIL_ACTION:
      return {
        ...state,
        loadingGeneration: false,
      };
    case actionTypes.ADD_REGWATERCARD_INIT_ACTION:
      return {
        ...state,
        loadingRegeneration: true,
      };
    case actionTypes.ADD_REGWATERCARD_SUCCESS_ACTION:
      return {
        ...state,
        loadingRegeneration: false,
      };
    case actionTypes.ADD_REGWATERCARD_FAIL_ACTION:
      return {
        ...state,
        loadingRegeneration: false,
      };
    default:
      return {
        ...state,
      };
  }
}
